import React from 'react';
import { PostProps } from '../types';
import { Body } from './Body';
import { Footer } from './Footer';
import { Header } from './Header';
import { usePost } from './hooks';
import { Container, ContentContainer, FooterContainer, Image, ImageContainer } from './styles';

export const Post: React.FC<PostProps> = (props) => {
  const {
    bodyProps,
    contentContainerProps,
    hasImage,
    headerProps,
    imageContainerProps,
    footerProps,
    imageProps,
    showFooter,
  } = usePost(props);

  const imageContent = <Image {...imageProps} />;

  return (
    <Container>
      {hasImage && <ImageContainer {...imageContainerProps}>{imageContent}</ImageContainer>}
      <ContentContainer {...contentContainerProps}>
        <Header {...headerProps} />
        <Body {...bodyProps} />
      </ContentContainer>
      {showFooter && (
        <FooterContainer>
          <Footer {...footerProps} />
        </FooterContainer>
      )}
    </Container>
  );
};
